export default {
  set: function (name, value, expires, path, domain, secure) {
    var cookieText = encodeURIComponent(name) + '=' +
      encodeURIComponent(value)
    if (expires instanceof Date) {
      cookieText += ';expires=' + expires.toGMTString()
    }
    if (path) {
      cookieText += ';path=' + path
    } else {
      cookieText += ';path=/'
    }
    if (domain) {
      cookieText += ';domain=' + domain
    }
    if (secure) {
      cookieText += ';secure'
    }
    document.cookie = cookieText
  },
  get: function (name) {
    var cookieName = encodeURIComponent(name) + '=',
      cookieStart = document.cookie.indexOf(cookieName),
      cookieValue = null
    if (cookieStart > -1) {
      var cookieEnd = document.cookie.indexOf(';', cookieStart)
      if (cookieEnd == -1) {
        cookieEnd = document.cookie.length
      }
      cookieValue = document.cookie.substring(cookieStart + cookieName.length, cookieEnd)
      try {
        cookieValue = decodeURIComponent(cookieValue)
      } catch (e) {
        cookieValue = document.cookie.substring(cookieStart + cookieName.length, cookieEnd)
      }
    }
    return cookieValue
  },
  unset: function (name, path, domain, secure) {
    this.set(name, '', '0', path, domain)
  }
}



// WEBPACK FOOTER //
// ./src/assets/cookieUtil.js